import SecureLS from "secure-ls";

var ls = new SecureLS();

export default ls;
